module.exports = __webpack_public_path__ + "img/ac7_thumb.4425dece.jpg";